<template>
  <div
    v-if="visible"
    class="modal fade show d-block"
    style="background: rgba(0, 0, 0, 0.5)"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">商品入庫</h5>
          <button type="button" class="btn-close" @click="$emit('close')">
            X
          </button>
        </div>
        <div class="modal-body">
          <div v-if="product" class="mb-3">
            <strong>商品：</strong> {{ product.name }}
          </div>
          <div class="form-group">
            <label>入庫數量</label>
            <input
              type="number"
              class="form-control"
              v-model.number="quantity"
              min="1"
            />
          </div>
          <div class="form-group">
            <label>備註</label>
            <textarea class="form-control" v-model="notes" rows="3"></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            @click="$emit('close')"
          >
            取消
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="handleInbound"
            :disabled="loading"
          >
            {{ loading ? "處理中..." : "確認入庫" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: "InboundModal",
  props: {
    visible: Boolean,
    productId: [String, Number],
  },
  data() {
    return {
      product: null,
      quantity: 1,
      notes: "",
      loading: false,
    };
  },
  watch: {
    visible(val) {
      if (val && this.productId) {
        this.fetchProduct();
      }
    },
  },
  methods: {
    async fetchProduct() {
      try {
        const response = await request.get(
          `/api/admin/products/${this.productId}`
        );
        this.product = response.data.data || response.data;
      } catch (error) {
        console.error("Failed to fetch product", error);
        this.$emit("error", "無法載入商品資訊");
      }
    },
    async handleInbound() {
      if (this.quantity <= 0) {
        this.$emit("error", "數量必須大於 0");
        return;
      }

      this.loading = true;
      try {
        await request.post("/api/admin/inventory/inbound", {
          product_id: this.productId,
          quantity: this.quantity,
          notes: this.notes,
        });
        this.$emit("success", `成功入庫 ${this.quantity} 件`);
        this.$emit("close");
        this.quantity = 1;
        this.notes = "";
      } catch (error) {
        console.error("Failed to process inbound", error);
        this.$emit("error", error.response?.data?.message || "入庫失敗");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
